import _legacy from "./legacy";
import _shades_classic from "./shades-classic";
import _shades_grey from "./shades-grey";
import _rect from "./rect";

export default {
  legacy: _legacy,
  shadesClassic: _shades_classic,
  shadesGrey: _shades_grey,
  rect: _rect,
};
